module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/thumbs/1-f00f134404c3c53cade93ec3b48fe877.webp";